// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   Box,
//   Typography,
//   Button,
//   Divider,
//   Chip,
// } from "@mui/material";
// import dayjs from "dayjs";

// const DetailRow = ({ label, value, isChip, chipColor }) => (
//   <Box
//     display="flex"
//     justifyContent="space-between"
//     mb={1.5}
//     alignItems="center"
//   >
//     <Typography
//       variant="body2"
//       color="textSecondary"
//       fontWeight={600}
//       sx={{ minWidth: 130 }}
//     >
//       {label}:
//     </Typography>
//     {isChip ? (
//       <Chip
//         label={value || "N/A"}
//         size="small"
//         color={chipColor || "default"}
//         variant="outlined"
//         sx={{ textTransform: "capitalize" }}
//       />
//     ) : (
//       <Typography
//         variant="body2"
//         sx={{ textAlign: "right", ml: 1, wordBreak: "break-word" }}
//       >
//         {value ?? "N/A"}
//       </Typography>
//     )}
//   </Box>
// );

// const SectionTitle = ({ children }) => (
//   <>
//     <Typography
//       variant="caption"
//       color="text.secondary"
//       fontWeight={700}
//       sx={{ textTransform: "uppercase", letterSpacing: 1 }}
//     >
//       {children}
//     </Typography>
//     <Divider sx={{ mb: 1.5, mt: 0.5 }} />
//   </>
// );

// const getStatusChipColor = (status) => {
//   switch (status?.toLowerCase()) {
//     case "new":         return "info";
//     case "in_progress": return "warning";
//     case "completed":   return "success";
//     case "cancelled":   return "error";
//     default:            return "default";
//   }
// };

// const getPriorityChipColor = (priority) => {
//   switch (priority?.toLowerCase()) {
//     case "high":   return "error";
//     case "medium": return "warning";
//     case "low":    return "success";
//     default:       return "default";
//   }
// };

// const JobActionDialogs = ({ open, type, data, onClose }) => {
//   if (!data) return null;

//   const headerColors = {
//     general: "#1976d2",
//     master:  "#2e7d32",
//     staff:   "#ed6c02",
//   };

//   const titles = {
//     general: "Job Execution Details",
//     master:  "Job Master Information",
//     staff:   "Staff & Site Details",
//   };

//   const headerColor = headerColors[type] || "#1976d2";

//   const fmt = (time) => (time ? time.substring(0, 5) : null); // HH:MM from HH:MM:SS
//   const fmtDate = (d) => (d ? dayjs(d).format("DD MMM YYYY") : null);

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
//       <DialogTitle sx={{ bgcolor: headerColor, color: "#fff", py: 1.5 }}>
//         <Typography variant="h6" fontSize="1rem">
//           {titles[type] || "Details"}
//         </Typography>
//       </DialogTitle>

//       <DialogContent dividers sx={{ pt: 2 }}>
//         {/* ── General / Execution ─────────────────────────────────────── */}
//         {type === "general" && (
//           <Box>
//             <SectionTitle>Schedule</SectionTitle>
//             <DetailRow label="Job Date"       value={fmtDate(data.job_date)} />
//             <DetailRow label="Planned Start"  value={fmt(data.planned_start_time)} />
//             <DetailRow label="Planned End"    value={fmt(data.planned_end_time)} />
//             <DetailRow label="Actual Start"   value={fmt(data.actual_start_time)} />
//             <DetailRow label="Actual End"     value={fmt(data.actual_end_time)} />

//             <SectionTitle>Status</SectionTitle>
//             <DetailRow
//               label="Status"
//               value={data.status?.replace("_", " ")}
//               isChip
//               chipColor={getStatusChipColor(data.status)}
//             />
//             <DetailRow
//               label="Priority"
//               value={data.priority}
//               isChip
//               chipColor={getPriorityChipColor(data.priority)}
//             />
//             <DetailRow
//               label="SLA (mins)"
//               value={data.sla_minutes != null ? `${data.sla_minutes} min` : null}
//             />
//             <DetailRow
//               label="SLA Breached"
//               value={data.is_sla_breached ? "Yes" : "No"}
//               isChip
//               chipColor={data.is_sla_breached ? "error" : "success"}
//             />

//             <SectionTitle>Tracking</SectionTitle>
//             <DetailRow label="Proof Count"    value={data.proof_count ?? 0} />
//             <DetailRow label="Latest Remark"  value={data.latest_remark} />
//           </Box>
//         )}

//         {/* ── Job Master ──────────────────────────────────────────────── */}
//         {type === "master" && (
//           <Box>
//             <SectionTitle>Template</SectionTitle>
//             <DetailRow label="Job Name"       value={data.job_name} />
//             <DetailRow label="Job Code"       value={data.job_code} />
//             <DetailRow label="Job Type"       value={data.job_type} />
//             <DetailRow label="Category"       value={data.job_category_name} />

//             <SectionTitle>Batch Context</SectionTitle>
//             <DetailRow label="Batch ID"       value={data.batch_id} />
//             <DetailRow label="Recurrence"     value={data.recurrence_type} />
//             <DetailRow label="Batch Start"    value={fmtDate(data.batch_start_date)} />
//             <DetailRow label="Batch End"      value={fmtDate(data.batch_end_date)} />
//             <DetailRow label="Assigned By"    value={data.assigned_by_name} />
//           </Box>
//         )}

//         {/* ── Staff & Site ─────────────────────────────────────────────── */}
//         {type === "staff" && (
//           <Box>
//             <SectionTitle>Staff</SectionTitle>
//             <DetailRow label="Staff Name"     value={data.staff_name} />

//             <SectionTitle>Customer</SectionTitle>
//             <DetailRow label="Customer"       value={data.customer_name} />

//             <SectionTitle>Site</SectionTitle>
//             <DetailRow label="Site Name"      value={data.site_name} />
//             <DetailRow label="Site Address"   value={data.site_address} />
//           </Box>
//         )}
//       </DialogContent>

//       <Box sx={{ p: 1.5, display: "flex", justifyContent: "flex-end" }}>
//         <Button
//           onClick={onClose}
//           variant="outlined"
//           size="small"
//           sx={{ borderColor: headerColor, color: headerColor }}
//         >
//           Close
//         </Button>
//       </Box>
//     </Dialog>
//   );
// };

// export default JobActionDialogs;


import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Button,
  Divider,
  Chip,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import configServ from "../../services/config";
import { appServiceName } from "../../services/http";

const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `${appServiceName}${url}`;
};

const DetailRow = ({ label, value, isChip, chipColor }) => (
  <Box
    display="flex"
    justifyContent="space-between"
    mb={1.5}
    alignItems="center"
  >
    <Typography
      variant="body2"
      color="textSecondary"
      fontWeight={600}
      sx={{ minWidth: 130 }}
    >
      {label}:
    </Typography>
    {isChip ? (
      <Chip
        label={value || "N/A"}
        size="small"
        color={chipColor || "default"}
        variant="outlined"
        sx={{ textTransform: "capitalize" }}
      />
    ) : (
      <Typography
        variant="body2"
        sx={{ textAlign: "right", ml: 1, wordBreak: "break-word" }}
      >
        {value ?? "N/A"}
      </Typography>
    )}
  </Box>
);

const SectionTitle = ({ children }) => (
  <>
    <Typography
      variant="caption"
      color="text.secondary"
      fontWeight={700}
      sx={{ textTransform: "uppercase", letterSpacing: 1 }}
    >
      {children}
    </Typography>
    <Divider sx={{ mb: 1.5, mt: 0.5 }} />
  </>
);

const getStatusChipColor = (status) => {
  switch (status?.toLowerCase()) {
    case "new":         return "info";
    case "in_progress": return "warning";
    case "completed":   return "success";
    case "cancelled":   return "error";
    default:            return "default";
  }
};

const getPriorityChipColor = (priority) => {
  switch (priority?.toLowerCase()) {
    case "high":   return "error";
    case "medium": return "warning";
    case "low":    return "success";
    default:       return "default";
  }
};

const JobActionDialogs = ({ open, type, data, onClose }) => {
  const [proofs, setProofs] = useState([]);
  const [loadingProofs, setLoadingProofs] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const fetchProofs = async () => {
      if (open && type === "general" && data?.id) {
        setLoadingProofs(true);
        try {
          const res = await configServ.getJobProofs(data.id);
          if (res?.status) {
            setProofs(res.data || []);
          } else {
            setProofs([]);
          }
        } catch (e) {
          console.error("Proof fetch error:", e);
          setProofs([]);
        } finally {
          setLoadingProofs(false);
        }
      }
    };

    if (open) {
      fetchProofs();
    } else {
      setProofs([]);
      setPreviewImage(null);
    }
  }, [open, type, data?.id]);

  if (!data) return null;

  const headerColors = {
    general: "#1976d2",
    master:  "#2e7d32",
    staff:   "#ed6c02",
  };

  const titles = {
    general: "Job Execution Details",
    master:  "Job Master Information",
    staff:   "Staff & Site Details",
  };

  const headerColor = headerColors[type] || "#1976d2";

  const fmt = (time) => (time ? time.substring(0, 5) : null);
  const fmtDate = (d) => (d ? dayjs(d).format("DD MMM YYYY") : null);

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle sx={{ bgcolor: headerColor, color: "#fff", py: 1.5 }}>
          <Typography variant="h6" fontSize="1rem">
            {titles[type] || "Details"}
          </Typography>
        </DialogTitle>

        <DialogContent dividers sx={{ pt: 2 }}>
          {type === "general" && (
            <Box>
              <SectionTitle>Schedule</SectionTitle>
              <DetailRow label="Job Date"       value={fmtDate(data.job_date)} />
              <DetailRow label="Planned Start"  value={fmt(data.planned_start_time)} />
              <DetailRow label="Planned End"    value={fmt(data.planned_end_time)} />
              <DetailRow label="Actual Start"   value={fmt(data.actual_start_time)} />
              <DetailRow label="Actual End"     value={fmt(data.actual_end_time)} />

              <SectionTitle>Status</SectionTitle>
              <DetailRow
                label="Status"
                value={data.status?.replace("_", " ")}
                isChip
                chipColor={getStatusChipColor(data.status)}
              />
              <DetailRow
                label="Priority"
                value={data.priority}
                isChip
                chipColor={getPriorityChipColor(data.priority)}
              />
              <DetailRow
                label="SLA (mins)"
                value={data.sla_minutes != null ? `${data.sla_minutes} min` : null}
              />
              <DetailRow
                label="SLA Breached"
                value={data.is_sla_breached ? "Yes" : "No"}
                isChip
                chipColor={data.is_sla_breached ? "error" : "success"}
              />

              <SectionTitle>Tracking</SectionTitle>
              <DetailRow
                label="Proof Count"
                value={loadingProofs ? "…" : proofs.length}
              />
              <DetailRow label="Latest Remark"  value={data.latest_remark} />

              <Box mt={1}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  fontWeight={600}
                  sx={{ mb: 1 }}
                >
                  Proofs:
                </Typography>

                {loadingProofs ? (
                  <Box display="flex" justifyContent="center" py={2}>
                    <CircularProgress size={22} />
                  </Box>
                ) : proofs.length > 0 ? (
                  <Box display="flex" gap={1} flexWrap="wrap">
                    {proofs.map((proof) => (
                      <Box
                        key={proof.id}
                        onClick={() =>
                          setPreviewImage(resolveImageUrl(proof.image_url))
                        }
                        sx={{
                          width: 64,
                          height: 64,
                          borderRadius: "8px",
                          overflow: "hidden",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          flexShrink: 0,
                          "&:hover": { opacity: 0.85 },
                        }}
                      >
                        <img
                          src={resolveImageUrl(proof.image_url)}
                          alt="Job proof"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography variant="caption" color="text.secondary">
                    No proof uploaded
                  </Typography>
                )}
              </Box>
            </Box>
          )}

          {type === "master" && (
            <Box>
              <SectionTitle>Template</SectionTitle>
              <DetailRow label="Job Name"       value={data.job_name} />
              <DetailRow label="Job Code"       value={data.job_code} />
              <DetailRow label="Job Type"       value={data.job_type} />
              <DetailRow label="Category"       value={data.job_category_name} />

              <SectionTitle>Batch Context</SectionTitle>
              <DetailRow label="Batch ID"       value={data.batch_id} />
              <DetailRow label="Recurrence"     value={data.recurrence_type} />
              <DetailRow label="Batch Start"    value={fmtDate(data.batch_start_date)} />
              <DetailRow label="Batch End"      value={fmtDate(data.batch_end_date)} />
              <DetailRow label="Assigned By"    value={data.assigned_by_name} />
            </Box>
          )}

          {type === "staff" && (
            <Box>
              <SectionTitle>Staff</SectionTitle>
              <DetailRow label="Staff Name"     value={data.staff_name} />

              <SectionTitle>Customer</SectionTitle>
              <DetailRow label="Customer"       value={data.customer_name} />

              <SectionTitle>Site</SectionTitle>
              <DetailRow label="Site Name"      value={data.site_name} />
              <DetailRow label="Site Address"   value={data.site_address} />
            </Box>
          )}
        </DialogContent>

        <Box sx={{ p: 1.5, display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            size="small"
            sx={{ borderColor: headerColor, color: headerColor }}
          >
            Close
          </Button>
        </Box>
      </Dialog>

      <Dialog
        open={!!previewImage}
        onClose={() => setPreviewImage(null)}
        maxWidth="lg"
        PaperProps={{
          sx: {
            bgcolor: "rgba(0,0,0,0.9)",
            boxShadow: "none",
            m: 0,
          },
        }}
      >
        <IconButton
          onClick={() => setPreviewImage(null)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#fff",
            bgcolor: "rgba(255,255,255,0.15)",
            "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        {previewImage && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ maxWidth: "90vw", maxHeight: "90vh", p: 2 }}
          >
            <img
              src={previewImage}
              alt="Job proof full view"
              style={{
                maxWidth: "100%",
                maxHeight: "85vh",
                objectFit: "contain",
                borderRadius: 4,
              }}
            />
          </Box>
        )}
      </Dialog>
    </>
  );
};

export default JobActionDialogs;